import { render, staticRenderFns } from "./firstAuditDetail.vue?vue&type=template&id=40b67884&scoped=true&"
import script from "./firstAuditDetail.vue?vue&type=script&lang=tsx&"
export * from "./firstAuditDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./firstAuditDetail.vue?vue&type=style&index=0&id=40b67884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b67884",
  null
  
)

export default component.exports